export default __webpack_public_path__ + "media/images/features/local_delivery/cta_ttl-d1bcbb4917de39c7fe222abd622eee93.png";